import BaseModel from '../core/BaseModel'

export default class UserTokenModel extends BaseModel {
    constructor() {
        super({
                name: "user_token",
                tableName: 'core_user_token'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
            },)
    }

}